// import React, { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";
// import Confetti from 'react-confetti';
// import { useWindowSize } from 'react-use'
// const Skill = ({ formData, setFormData }) => {
//   const [focusedField, setFocusedField] = useState(null);
//   const Roles = ["CXO", "Product", "Quality", "Engineering", "Others"];
//   const Skills = ["QA Automation", "Sanity Testing", "Design", "Others"];
// const [isExploding, setIsExploding] = useState(false);
//   const FullScreenConfetti = ({ isExploding }) => {
//   const { width, height } = useWindowSize();

//   return isExploding ? <Confetti width={width} height={height} /> : null;
// };

//   const handleRoleChange = (event) => {
//     const newRole = event.target.value;
//     setFormData((prevData) => ({
//       ...prevData,
//       role: newRole,
//     }));
//   };

//   const handleSkillChange = (event) => {
//     const newSkill = event.target.value;
//     setFormData((prevData) => ({
//       ...prevData,
//       skill: newSkill,
//     }));
//   };

//   return (
//     <>
//     {isExploding && <FullScreenConfetti isExploding={true} />}

//     <div className="flex flex-col items-start justify-start w-full">
//       <div className="flex flex-col justify-start mb-4">
//         <h1 className="text-2xl font-semibold text-[#181D27] mb-1">Tell us who you are</h1>
//         <p className="text-xl text-[#717680]">
//           This will allow us to build better testing capabilities.
//         </p>
//       </div>

//       {/* Role Select */}
//       <div className="relative w-2/5 mb-6">
//         <label
//           htmlFor="role"
//           className="block mb-2 text-base font-semibold text-gray-700"
//         >
//           What is your department?
//         </label>

//         <select
//           id="role"
//           name="role"
//           value={formData.role}
//           onFocus={() => setFocusedField("role")}
//           onBlur={() => setFocusedField(null)}
//           onChange={handleRoleChange}
//           className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
//         >
//           <option value="">Select Department</option>
//           {Roles.map((role, i) => (
//             <option key={i} value={role}>
//               {role}
//             </option>
//           ))}
//         </select>

//         <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
//           {focusedField === "role" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//         </div>
//       </div>

//       {/* Skill Select */}
//       <div className="relative w-2/5">
//         <label
//           htmlFor="skill"
//           className="block mb-2 text-base font-semibold text-gray-700"
//         >
//           What is your purpose of using TestTube?
//         </label>

//         <select
//           id="skill"
//           name="skill"
//           value={formData.skill}
//           onFocus={() => setFocusedField("skill")}
//           onBlur={() => setFocusedField(null)}
//           onChange={handleSkillChange}
//           className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
//         >
//           <option value="">Select Purpose</option>
//           {Skills.map((skill, i) => (
//             <option key={i} value={skill}>
//               {skill}
//             </option>
//           ))}
//         </select>

//         <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
//           {focusedField === "skill" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//         </div>
//       </div>

//         <button
//                 className="bg-[#5049AC] font-semibold text-white px-5 py-2 rounded-lg text-[16px] disabled:opacity-50 disabled:cursor-not-allowed"
//                onClick={() => setIsExploding(true)}
//               >
//                 confetti
//               </button>
//     </div>
//     </>
//   );
// };

// export default Skill;



// import React, { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";
// import Confetti from "react-confetti";
// import { useWindowSize } from "react-use";

// const Skill = ({ formData, setFormData }) => {
//   const [focusedField, setFocusedField] = useState(null);
//   const [isExploding, setIsExploding] = useState(false);
//   const { width, height } = useWindowSize();

//   const Roles = ["CXO", "Product", "Quality", "Engineering", "Others"];
//   const Skills = ["QA Automation", "Sanity Testing", "Design", "Others"];

//   const handleRoleChange = (event) => {
//     setFormData((prev) => ({ ...prev, role: event.target.value }));
//   };

//   const handleSkillChange = (event) => {
//     setFormData((prev) => ({ ...prev, skill: event.target.value }));
//   };

//   return (
//     <>
//       {isExploding && (
//         <Confetti
//           width={width}
//           height={height}
//           numberOfPieces={1000}
//           recycle={false}
//           onConfettiComplete={(confetti) => {
//             confetti?.reset();
//             setIsExploding(false);
//           }}
//         />
//       )}

//       <div className="flex flex-col items-start justify-start w-full">
//         <div className="flex flex-col justify-start mb-4">
//           <h1 className="text-2xl font-semibold text-[#181D27] mb-1">Tell us who you are</h1>
//           <p className="text-xl text-[#717680]">
//             This will allow us to build better testing capabilities.
//           </p>
//         </div>

//         {/* Department */}
//         <div className="relative w-2/5 mb-6">
//           <label htmlFor="role" className="block mb-2 text-base font-semibold text-gray-700">
//             What is your department?
//           </label>
//           <select
//             id="role"
//             name="role"
//             value={formData.role}
//             onFocus={() => setFocusedField("role")}
//             onBlur={() => setFocusedField(null)}
//             onChange={handleRoleChange}
//             className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
//           >
//             <option value="">Select Department</option>
//             {Roles.map((role, i) => (
//               <option key={i} value={role}>{role}</option>
//             ))}
//           </select>
//           <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
//             {focusedField === "role" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//           </div>
//         </div>

//         {/* Purpose */}
//         <div className="relative w-2/5 mb-6">
//           <label htmlFor="skill" className="block mb-2 text-base font-semibold text-gray-700">
//             What is your purpose of using TestTube?
//           </label>
//           <select
//             id="skill"
//             name="skill"
//             value={formData.skill}
//             onFocus={() => setFocusedField("skill")}
//             onBlur={() => setFocusedField(null)}
//             onChange={handleSkillChange}
//             className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
//           >
//             <option value="">Select Purpose</option>
//             {Skills.map((skill, i) => (
//               <option key={i} value={skill}>{skill}</option>
//             ))}
//           </select>
//           <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
//             {focusedField === "skill" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//           </div>
//         </div>

//         <button
//           className="bg-[#5049AC] font-semibold text-white px-5 py-2 rounded-lg text-[16px] disabled:opacity-50 disabled:cursor-not-allowed"
//           onClick={() => setIsExploding(true)}
//         >
//           Launch Confetti
//         </button>
//       </div>
//     </>
//   );
// };

// export default Skill;


import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import confetti from "canvas-confetti";

const Skill = ({ formData, setFormData }) => {
  const [focusedField, setFocusedField] = useState(null);
  // const [isExploding, setIsExploding] = useState(false);

  const Roles = ["CXO", "Product", "Quality", "Engineering", "Others"];
  const Skills = ["QA Automation", "Sanity Testing", "Design", "Others"];

  const handleRoleChange = (event) => {
    setFormData((prev) => ({ ...prev, role: event.target.value }));
  };

  const handleSkillChange = (event) => {
    setFormData((prev) => ({ ...prev, skill: event.target.value }));
  };

  // useEffect(() => {
  //   if (isExploding) {
  //     triggerExplosion();
  //     setIsExploding(false);
  //   }
  // }, [isExploding]);

  // const triggerExplosion = () => {
  //   const duration = 400;
  //   const animationEnd = Date.now() + duration;
  //   const defaults = {
  //     startVelocity: 30,
  //     spread: 360,
  //     ticks: 120,
  //     zIndex: 999,
  //     scalar: 1.2,
  //     particleCount: 100,
  //     origin: { y: 0.6 }
  //   };

  //   const interval = setInterval(() => {
  //     if (Date.now() > animationEnd) {
  //       return clearInterval(interval);
  //     }

  //     confetti({
  //       ...defaults,
  //       angle: Math.random() * 360,
  //       origin: {
  //         x: Math.random(),
  //         y: Math.random() * 0.5,
  //       },
  //     });
  //   }, 50);
  // };

  return (
    <div className="flex flex-col items-start justify-start w-full">
      <div className="flex flex-col justify-start mb-4">
        <h1 className="text-2xl font-semibold text-[#181D27] mb-1">Tell us who you are</h1>
        <p className="text-xl text-[#717680]">
          This will allow us to build better testing capabilities.
        </p>
      </div>

      {/* Department */}
      <div className="relative w-2/5 mb-6">
        <label htmlFor="role" className="block mb-2 text-base font-semibold text-gray-700">
          What is your department?
        </label>
        <select
          id="role"
          name="role"
          value={formData.role}
          onFocus={() => setFocusedField("role")}
          onBlur={() => setFocusedField(null)}
          onChange={handleRoleChange}
          className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
        >
          <option value="">Select Department</option>
          {Roles.map((role, i) => (
            <option key={i} value={role}>{role}</option>
          ))}
        </select>
        <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
          {focusedField === "role" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </div>
      </div>

      {/* Purpose */}
      <div className="relative w-2/5 mb-6">
        <label htmlFor="skill" className="block mb-2 text-base font-semibold text-gray-700">
          What is your purpose of using TestTube?
        </label>
        <select
          id="skill"
          name="skill"
          value={formData.skill}
          onFocus={() => setFocusedField("skill")}
          onBlur={() => setFocusedField(null)}
          onChange={handleSkillChange}
          className="w-full bg-[#F9F9F9] appearance-none px-4 py-2 pr-10 border border-[#D5D7DA] rounded-md text-sm focus:outline-none cursor-pointer"
        >
          <option value="">Select Purpose</option>
          {Skills.map((skill, i) => (
            <option key={i} value={skill}>{skill}</option>
          ))}
        </select>
        <div className="absolute right-3 top-[75%] -translate-y-1/2 pointer-events-none text-gray-500">
          {focusedField === "skill" ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </div>
      </div>

     
    </div>
  );
};

export default Skill;
